export enum MarketplaceItemAttributeDisplayType {
  Free_Text = 0,
  Date = 1,
  Date_No_Expire = 2,
  Colour = 3,
  Other = 4,
}
